import React from 'react';
import { useNavigate } from 'react-router-dom';

const CATALOG = [
  {
    id: 1,
    name: 'Royal Palpali Floral Mandap',
    price: 'NPR 45,000 / setup',
    desc: 'Traditional Palpali wedding mandap decorated with fresh marigolds, red roses, gold velvet drapes, and ceremonial brass oil lamps.',
    tag: 'Palpali Mandap',
    emoji: '🌸'
  },
  {
    id: 2,
    name: 'Yogikuti Grand Stage Backdrop',
    desc: 'Elevated reception stage backdrop featuring crystal chandeliers, royal thrones, LED accent lighting, and white floral arches.',
    price: 'NPR 60,000 / setup',
    tag: 'Stage Backdrop',
    emoji: '🎭'
  },
  {
    id: 3,
    name: 'Fairy Light & Marquee Canopy',
    desc: 'Romantic outdoor marquee tent canopy with warm Edison bulbs, fairy light strings, and full wooden flooring setup.',
    price: 'NPR 28,000 / setup',
    tag: 'Marquee Tent',
    emoji: '✨'
  }
];

export default function Catalog() {
  const navigate = useNavigate();

  return (
    <div className="sec-wrapper">
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI MANDAP DECOR & TENT HOUSE ✦
            </span>
          </div>

          <h1 className="hero-title">
            Mandap Decor & <span className="hero-title-gradient">Tent Setup Catalog</span>
          </h1>

          <p className="hero-subtitle">
            Managed by <strong>Krishna Khanal</strong> (9867155395) & Partner <strong>Laxmikant Timilsina</strong>. Main Corporate Office: <strong>Yogikuti Chowk, Butwal-10, Nepal</strong>.
          </p>

          <div className="hero-cta-group">
            <button className="btn btn-secondary" onClick={() => navigate('/decor/quote')}>
              Request Custom Quote →
            </button>
            <button className="btn btn-tertiary" onClick={() => navigate('/decor/booking')}>
              Book Decor Package →
            </button>
          </div>
        </div>
      </section>

      {/* Catalog Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
        gap: '2rem',
        marginBottom: '3.5rem'
      }}>
        {CATALOG.map((item) => (
          <div key={item.id} className="card pillar-card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                <div style={{ fontSize: '2.5rem' }}>{item.emoji}</div>
                <span className="badge-light">{item.tag}</span>
              </div>

              <h3 style={{ fontSize: '1.65rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.2rem', fontFamily: 'var(--serif)' }}>
                {item.name}
              </h3>
              <div style={{ fontSize: '1.4rem', fontWeight: 900, color: '#8C6A23', marginBottom: '0.8rem' }}>
                {item.price}
              </div>
              <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.5rem' }}>
                {item.desc}
              </p>
            </div>

            <div>
              <a href="tel:9867155395" className="btn btn-primary btn-full">
                📞 Request Setup with Krishna (9867155395) →
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}